import React from 'react';
import { Checkbox, Radio } from 'antd';
import update from 'immutability-helper';
import styles from './styles.scss';

const SessionSelect = (props) => {
  const { productSlug, quizState, setOptions } = props;
  const { greQuantItemsReady, greVocabItemsReady, itemsReady, options } = quizState;
  const { fill, shuffle, size } = options;
  const isGre = productSlug === 'gre';

  const handleChangeSize = (e) => {
    const size = e.target.value;

    const nextOptions = update(options, { size: { $set: size } });
    setOptions(nextOptions);
  };

  const handleChangeFill = () => {
    const nextOptions = update(options, { fill: { $set: !fill } });
    setOptions(nextOptions);
  };

  const handleChangeShuffle = () => {
    const nextOptions = update(options, { shuffle: { $set: !shuffle } });
    setOptions(nextOptions);
  };

  return (
    <div className={styles.layout}>
      <div className={styles.layoutInner}>
        <div className={styles.ready}>
          <div>Reviews ready: {itemsReady}</div>
          {isGre && (
            <div>
              ({greQuantItemsReady} quant, {greVocabItemsReady} vocab)
            </div>
          )}
          <br />
          <div>Max number of questions in a batch</div>
          <Radio.Group defaultValue={size} onChange={handleChangeSize}>
            <Radio.Button value={10}>10</Radio.Button>
            <Radio.Button value={25}>25</Radio.Button>
            <Radio.Button value={50}>50</Radio.Button>
            <Radio.Button value={100}>100</Radio.Button>
          </Radio.Group>
          <br />
          <div className={styles.checkboxes}>
            <Checkbox checked={fill} onChange={handleChangeFill}>
              Repeat formula-based questions to drill math?
            </Checkbox>
            <Checkbox checked={shuffle} onChange={handleChangeShuffle}>
              Ignore personalization and randomize question order?
            </Checkbox>
          </div>
        </div>

        <div className={styles.instructions}>
          <div className={styles.instructionsHeader}>Tips and tricks</div>
          <ul className={styles.instructionsList}>
            <li>
              Click the <i className="fad fa-sliders-v" /> sliders icon on the top right
              of this screen to filter by topic
            </li>
            <li>
              Click the <i className="fad fa-share-square" /> share icon on a quiz to copy
              a shareable URL for coworkers, tutors, or support
            </li>
            <li>
              {' '}
              Unlock more quizzes by clicking the &quot;Complete&quot; button at the end
              of a textbook page
            </li>
          </ul>
        </div>
        <div className={styles.readyInfo}>
          Achievable models the strength of your memory using learning science. When
          reviews are &quot;ready&quot; it means refreshing your memory at this time will
          be very effective. You can still review content even if it isn&apos;t ready, but
          that might be a good time to read more of the text.
          <div className={styles.copyright}>
            All rights reserved &copy;2016 - {new Date().getFullYear()} Achievable, Inc.
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionSelect;
